import React, {Component} from 'react'
import {withSnackbar } from 'notistack'
import ImageViewer from 'react-images-viewer'

import Field from '../../common/Field'
import {addFeeds, uploadImages, deleteImages} from '../../../repository/ConfigurationsRepository'
import _ from 'lodash'
import LoadingScreen from '../../common/LoadingScreen'
import ConfirmationBox from '../../common/ConfirmationBox'

//material-ui components
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import CancelIcon from '@material-ui/icons/Cancel'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'


//firebase
import FirebaseApp from '../../../FirebaseSetup'

class Delete extends Component {

    constructor(props){
        super(props)
        this.state={
            feedId:this.props.feed.feedId,
            feedName:this.props.feed.feedName,
            feedType:this.props.feed.feedType,
            activeDays:this.props.feed.activeDays,
            status:this.props.feed.status,
            images:this.props.feed.images,
            addedImages:[],
            deletedImages:[],
            loading:{
                status:false,
                message:''
            },
            fileInput:'',
            confirm:{
                status:false,
                message:''
            },
            imageViewer:{
                images:'',
                status:false
            }
        }
        this.inputRef = React.createRef()
    }

    openImageViewer = (e) => {
        let arr = []
        let img = {src:e.target.src}
        arr.push(img)
        this.setState({imageViewer:{images:arr,status:true}})
    }

    closeImageViewer = () => {
        this.setState({imageViewer:{images:[],status:false}})
    }

    addImage = (e) => {
        let imageFile = {
            url : URL.createObjectURL(e.target.files[0]),
            file : e.target.files[0]
        }
        let arr = this.state.addedImages.concat(imageFile)
        this.setState({ addedImages:arr})
    }

    deleteNewImage = (e) => {
        let arr =  this.state.addedImages.filter(file => e.currentTarget.value!=file.url)
        this.setState({addedImages:arr})
    }

    deleteOldImage = (e) => {
        let imageList = this.state.images
        var imagesToDelete = _.remove(imageList, (n) => {
           return n.id == e.currentTarget.value
        });
        let deletedImages = this.state.deletedImages
        deletedImages.concat(imagesToDelete)
        this.setState({deletedImages:deletedImages})
        this.setState({images:imageList})
        console.log('hello',imageList)
    }


    updateFeed = async () => {


            try{
                if(this.state.images.length!=0){
                    this.setState({loading:{status:true,message:'Deleting old images'}})
                    await deleteImages(this.state.images, 'feeds')
                }


                let feeds = this.props.feedList

                var deletedFeed = _.remove(feeds.feedList, (n) => {
                return n.feedId == this.state.feedId
                });

                console.log(feeds)
                console.log(deletedFeed)

                this.setState({loading:{status:true,message:'Updating feeds'}})
                await FirebaseApp.auth().currentUser.getIdToken(true).then(async (idToken) => {
                        await addFeeds(idToken,feeds)
                        this.props.enqueueSnackbar("Feeds were updated successfully",{variant:'success'})
                    })
                this.props.handleCloseWithRefresh()
            }catch(error){
                this.props.enqueueSnackbar("Update feeds was failed"+error,{variant:'error'})
            }finally{
                this.setState({loading:{status:false,message:''}})
            }
         
        
    }

    
    render() {
        return (
            <div>
                 <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    style={{display: 'flex', alignItems: 'center',justifyContent: 'center'}}
                    open={this.props.open}
                    onClose={this.props.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    disableBackdropClick={true}
                    BackdropProps={{
                    timeout: 500,
                    }}
                >
                    <Fade in={this.props.open}>
                    <div style={{backgroundColor:'white',width:'850px',position:'relative',paddingBottom:'20px'}}
                    className="bg-light"
                    >
                    <div style={{margin:'20px'}}>
                        <h4>Delete Feed</h4>
                        <br></br>
                        <div className='row'>
                            <div className='col-lg-6'>
                            
                                    <FormControl variant="outlined" style={{width:'180px'}}>
                                        <InputLabel id="demo-simple-select-outlined-label">Status</InputLabel>
                                        <Select
                                            disabled
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={this.state.status}
                                            onChange = {(e)=>{this.setState({status:e.target.value})}}
                                            autoWidth
                                            style={{fontSize:'12px'}}
                                            displayEmpty={true}
                                            defaultValue={this.props.defaultValue}
                                        >
                                            <MenuItem value="ACTIVE">Active</MenuItem>
                                            <MenuItem value="PAUSED">Paused</MenuItem>
                                        
                                            </Select>
                                    </FormControl>
                                    
                                <Field
                                    disabled
                                    type='text'
                                    id='name'
                                    placeholder='Feed Name'
                                    size='small'
                                    value = {this.state.feedName}
                                    onChange = {(e)=>{this.setState({feedName:e.target.value})}}
                                    autoFocus={false}
                                    required={true}
                                />
                                <Field
                                    disabled
                                    type='text'
                                    id='type'
                                    placeholder='Feed Type'
                                    size='small'
                                    value = {this.state.feedType}
                                    onChange = {(e)=>{this.setState({feedType:e.target.value})}}
                                    autoFocus={false}
                                />
                                <Field
                                    disabled
                                    type='text'
                                    id='activeDays'
                                    placeholder='Active Days'
                                    value = {this.state.activeDays}
                                    onChange = {(e)=>{this.setState({activeDays:e.target.value})}}
                                    size='small'
                                    autoFocus={false}
                                    required={true}
                                />
                                 
                            </div>
                            <div className='col-lg-6' style={{paddingTop:'15px'}}>
                            <div style={{ height:'200px',overflowY:'auto',overflowX:'hidden',width:'100%'}}>
                                {this.state.images.map((image, i) => {
                                    return (
                                        <Card style={{width:'360px',marginBottom:'10px'}}>
                                            <img 
                                                style={{width:'360px',height:'100px',objectFit:'cover'}} 
                                                onClick = {(e)=>this.openImageViewer(e)}
                                                src={image.url} 
                                                alt={''}/>
                                        </Card>
                                    )
                                })}
                                {this.state.images.length==0?
                                     <div style={{width:'100%',height:'200px',display:'flex',flexDirection:'column'}}>
                                         <div style={{margin:'auto'}}>No images are added</div>
                                         </div>
                                    :null
                                }
                            </div>
                            </div>
                        </div>
                        <br></br>
                        <div className='d-flex flex-direction-row float-right'>
                        <Button
                                variant="contained"
                                startIcon={<CancelIcon/>}
                                size = "small"
                                onClick = {(e) => {
                                    this.props.handleClose()
                                }}
                                style={{marginRight:'10px'}}
                                color="secondary"
                            >Cancel
                        </Button>

                        <Button
                                variant="contained"
                                startIcon={<CheckCircleIcon/>}
                                size = "small"
                                onClick = {(e) => {
                                    this.setState({confirm:{message:'Confirm',status:true}})
                                }}
                                color="primary"
                            >Delete Feed
                        </Button>
                        </div>
                        </div>
                    {this.state.loading.status?
                    <   LoadingScreen
                        width='100%'
                        height='100%'
                        translateY ='200px'
                        message = {this.state.loading.message}
                    />
                    :null    
                    }
                    {this.state.confirm.status?
                    <   ConfirmationBox
                        open={this.state.confirm.status}
                        message = {this.state.confirm.message}
                        handleClose = {(e)=>{this.setState({confirm:{...this.state.confirm,status:false}})}}
                        handleCloseConfirmed = {
                            (e)=>{
                                this.setState({confirm:{...this.state.confirm,status:false}})
                                this.updateFeed()
                            }
                            
                        }
                    />
                    :null    
                    }
                    {this.state.imageViewer.status?
                            <ImageViewer
                            imgs={ this.state.imageViewer.images }
                            currImg={0}
                            isOpen = {this.state.imageViewer.status}
                            onClose={ this.closeImageViewer }
                            />
                            : null    
                    }
                    </div>
                    </Fade>
                </Modal>
            </div>
        )
    }
}
export default withSnackbar(Delete)